import { Moment } from 'moment'

// Subtract moment offset utc
export const subtractToUtcOffsetFn = (date: Moment) => {
  const offset = date.utcOffset()
  return date.clone().subtract(offset, 'minutes')
}
